const STROKE = '#D7DADA';

// `sx` and `fontSize` are swallowed: this is a plain SVG, not a MUI icon, and its stroke is fixed
// by the design rather than following the option's selected state.
const BankTransferIcon = ({ sx, fontSize, ...props }) => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path d="M3 21H21" stroke={STROKE} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M3 10H21" stroke={STROKE} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M5 6L12 3L19 6" stroke={STROKE} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M4 10V21" stroke={STROKE} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M20 10V21" stroke={STROKE} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M8 14V17" stroke={STROKE} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M12 14V17" stroke={STROKE} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M16 14V17" stroke={STROKE} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);

export default BankTransferIcon;
